import React from 'react';
import { Stack } from '@mui/material';

import AssetTitlePanel from '../components/AssetTitlePanel';
import {Asset} from "../../../classes/Asset";

function AssetSummaryLayout(props: {
    assetData: Asset
}) {

    return (
        <Stack direction="column" padding={2} spacing={2}>
            <AssetTitlePanel sx={{ width: '100%' }} assetData={props.assetData} />
        </Stack>
    );
}

export default AssetSummaryLayout;